import { initializeApp } from 'firebase/app';
import { browserSessionPersistence, connectAuthEmulator, initializeAuth } from 'firebase/auth';

// Web app config for Firebase project kabilah-mobile-app, the same project the
// Kabilah mobile app signs nurses into. These are public identifiers, not secrets.
// Analytics (measurementId) is deliberately left out: no tracking in a PHI app.
const firebaseConfig = {
  apiKey: 'AIzaSyCM6iQGAzL82-D-w-1sOI-f46URsgkL3Uk', // gitleaks:allow - Firebase web API key, public by design (identifies the project; access is enforced by Firebase Auth and security rules)
  authDomain: 'kabilah-mobile-app.firebaseapp.com',
  projectId: 'kabilah-mobile-app',
  storageBucket: 'kabilah-mobile-app.appspot.com',
  messagingSenderId: '1046227227245',
  appId: '1:1046227227245:web:c938b9778430acd263e564',
};

const app = initializeApp(firebaseConfig);

// Session persistence: closing the tab signs the nurse out, since the dashboard
// runs on shared hospital workstations.
export const auth = initializeAuth(app, { persistence: browserSessionPersistence });

// Local testing against the Firebase Auth emulator only.
const emulatorHost = process.env.REACT_APP_FIREBASE_AUTH_EMULATOR_HOST;
if (emulatorHost) {
  connectAuthEmulator(auth, `http://${emulatorHost}`, { disableWarnings: true });
}
